import type { BackendMatches } from '../matches/types';
import type { BackendObjects } from '../objects/types';
import type { BackendSports } from '../sports/types';
import type { BackendStages } from '../stages/types';
import type { BackendTournaments } from '../tournaments/types';
import type { BackendUnions } from '../unions/types';

// ---

export type BackendEntitiesDiff = {
  serverTime?: string;
  reset?: boolean;
  sports?: BackendSports;
  tournamentUnions?: BackendUnions;
  tournaments?: BackendTournaments;
  tournamentStages?: BackendStages;
  objects?: BackendObjects;
  matches?: BackendMatches;
  removedMatches?: number[];
  sportMatchesCount?: Record<string, number>;
  tournamentMatchesCount?: Record<string, number>;
  tournamentStageMatchesCount?: Record<string, number>;
  tournamentUnionMatchesCount?: Record<string, number>;
};

export const enum Topic {
  LIVE = 'live',
  PREMATCH = 'pre-match',
  INTERESTING_MATCHES = 'interesting-matches',
}

export type BackendEntities = {
  topic: Topic | string;
  diff: BackendEntitiesDiff;
};
